import Cookies from 'universal-cookie';

export function isLogged(): boolean {
    const cookies = new Cookies();
    return cookies.get("logged_in")
}